import { buildModelManager } from "../builder.js";
const DefaultUserSelection = {
  __typename: true,
  id: true,
  completedTours: true,
  createdAt: true,
  email: true,
  emailVerificationToken: true,
  emailVerificationTokenExpiration: true,
  emailVerified: true,
  firstName: true,
  googleImageUrl: true,
  googleProfileId: true,
  lastName: true,
  lastSignedIn: true,
  profilePicture: { url: true, mimeType: true, fileName: true },
  profilePictureUrl: true,
  referredByProfileId: true,
  resetPasswordToken: true,
  resetPasswordTokenExpiration: true,
  roles: { key: true, name: true },
  sidebarCollapsed: true,
  stripeCustomerId: true,
  tier: true,
  toursDisabled: true,
  updatedAt: true,
  uuid: true
};
const modelApiIdentifier = "user";
const pluralModelApiIdentifier = "users";
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByUuid",
    findByField: "uuid",
    findByVariableName: "uuid",
    modelApiIdentifier,
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByUuid",
    findByField: "uuid",
    findByVariableName: "uuid",
    modelApiIdentifier,
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByEmail",
    findByField: "email",
    findByVariableName: "email",
    modelApiIdentifier,
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByEmail",
    findByField: "email",
    findByVariableName: "email",
    modelApiIdentifier,
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByStripeCustomerId",
    findByField: "stripeCustomerId",
    findByVariableName: "stripeCustomerId",
    modelApiIdentifier,
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByStripeCustomerId",
    findByField: "stripeCustomerId",
    findByVariableName: "stripeCustomerId",
    modelApiIdentifier,
    defaultSelection: DefaultUserSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "signUpUser",
    operationReturnType: "SignUpUser",
    functionName: "signUp",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      refCode: { required: false, type: "String" },
      email: { required: true, type: "String" },
      password: { required: true, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["refCode"],
    hasReturnType: true,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkSignUpUsers",
    functionName: "bulkSignUp",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: false,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "signUp",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkSignUpUsersInput!]" } },
    paramOnlyVariables: ["refCode"],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "signInUser",
    operationReturnType: "SignInUser",
    functionName: "signIn",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      email: { required: true, type: "String" },
      password: { required: true, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkSignInUsers",
    functionName: "bulkSignIn",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "signIn",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkSignInUsersInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "signOutUser",
    operationReturnType: "SignOutUser",
    functionName: "signOut",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkSignOutUsers",
    functionName: "bulkSignOut",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "signOut",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "updateUser",
    operationReturnType: "UpdateUser",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      user: { required: false, type: "UpdateUserInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateUsers",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateUsersInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "deleteUser",
    operationReturnType: "DeleteUser",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteUsers",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "sendVerifyEmailUser",
    operationReturnType: "SendVerifyEmailUser",
    functionName: "sendVerifyEmail",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { email: { required: true, type: "String" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: true,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkSendVerifyEmailUsers",
    functionName: "bulkSendVerifyEmail",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "sendVerifyEmail",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkSendVerifyEmailUsersInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "verifyEmailUser",
    operationReturnType: "VerifyEmailUser",
    functionName: "verifyEmail",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { code: { required: true, type: "String" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: true,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkVerifyEmailUsers",
    functionName: "bulkVerifyEmail",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "verifyEmail",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkVerifyEmailUsersInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "sendResetPasswordUser",
    operationReturnType: "SendResetPasswordUser",
    functionName: "sendResetPassword",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { email: { required: true, type: "String" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: true,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkSendResetPasswordUsers",
    functionName: "bulkSendResetPassword",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "sendResetPassword",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkSendResetPasswordUsersInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "resetPasswordUser",
    operationReturnType: "ResetPasswordUser",
    functionName: "resetPassword",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      password: { required: true, type: "String" },
      code: { required: true, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: true,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkResetPasswordUsers",
    functionName: "bulkResetPassword",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "resetPassword",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkResetPasswordUsersInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "changePasswordUser",
    operationReturnType: "ChangePasswordUser",
    functionName: "changePassword",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      currentPassword: { required: true, type: "String" },
      newPassword: { required: true, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkChangePasswordUsers",
    functionName: "bulkChangePassword",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "changePassword",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkChangePasswordUsersInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "assignRoleUser",
    operationReturnType: "AssignRoleUser",
    functionName: "assignRole",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      user: { required: false, type: "AssignRoleUserInput" },
      role: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["role"],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkAssignRoleUsers",
    functionName: "bulkAssignRole",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "assignRole",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkAssignRoleUsersInput!]" } },
    paramOnlyVariables: ["role"],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "sendMagicLinkUser",
    operationReturnType: "SendMagicLinkUser",
    functionName: "sendMagicLink",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      user: { required: false, type: "SendMagicLinkUserInput" },
      inviteToken: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["inviteToken"],
    hasReturnType: true,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkSendMagicLinkUsers",
    functionName: "bulkSendMagicLink",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "sendMagicLink",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkSendMagicLinkUsersInput!]" }
    },
    paramOnlyVariables: ["inviteToken"],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "signInViaTokenUser",
    operationReturnType: "SignInViaTokenUser",
    functionName: "signInViaToken",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkSignInViaTokenUsers",
    functionName: "bulkSignInViaToken",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "signInViaToken",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "upsertUser",
    operationReturnType: "UpsertUser",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      user: { required: false, type: "UpsertUserInput" },
      refCode: { required: false, type: "String" },
      email: { required: true, type: "String" },
      password: { required: true, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on", "refCode"],
    hasReturnType: {
      "... on SignUpUserResult": { hasReturnType: true },
      "... on UpdateUserResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultUserSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertUsers",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: {
      users: {
        hasReturnType: {
          "... on User": { select: true },
          "... on UpsertUserReturnType": { hasReturnType: true }
        }
      }
    },
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertUsersInput!]" } },
    paramOnlyVariables: ["on", "refCode"],
    defaultSelection: DefaultUserSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "userGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const UserManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultUserSelection,
  operations
);
export {
  DefaultUserSelection,
  UserManager
};
//# sourceMappingURL=User.js.map
